import { setInteractionMode, ValidationProvider } from 'vee-validate';
import { regrasExigemPreenchimento } from '@/velta/utils/regrasObrigatorias';

setInteractionMode('eager');

/* -------------------------------------------------------------------------
 * Marcação global de campo obrigatório / opcional
 *
 * O ValidationProvider renderiza `h(this.tag, children)` sem binding de class.
 * Envolvemos o render só para carimbar uma classe na raiz; o asterisco e o
 * "(opcional)" são desenhados por CSS (::after no label), em
 * assets/scss/_campos-obrigatorios.scss. Assim nenhum dos 140 arquivos que
 * usam <b-form-group> precisa ser tocado, e a marcação também alcança os
 * <label> soltos (padrão do CadastroEmpresa.vue).
 * ---------------------------------------------------------------------- */
const CLASSE_OBRIGATORIO = 'velta-campo-obrigatorio';
const CLASSE_OPCIONAL = 'velta-campo-opcional';

const opcoesProvider = ValidationProvider.options;
const renderOriginal = opcoesProvider.render;

const renderComMarcacao = function render(h) {
    const vnode = renderOriginal.call(this, h);

    // Com `slim` o retorno é o próprio filho (que pode ser outro componente):
    // não marcamos, para não vazar a classe para dentro dele.
    if (!vnode || !vnode.tag || this.slim) return vnode;

    // Não usar `this.isRequired` do vee-validate aqui: essa computed escreve em
    // `this.flags.required` como efeito colateral, e mutar estado reativo dentro
    // do render provocaria um render extra em cada campo do formulário.
    const classe = regrasExigemPreenchimento(this.rules) ? CLASSE_OBRIGATORIO : CLASSE_OPCIONAL;

    vnode.data = vnode.data || {};
    vnode.data.staticClass = vnode.data.staticClass
        ? `${vnode.data.staticClass} ${classe}`
        : classe;

    return vnode;
};

opcoesProvider.render = renderComMarcacao;
// Se as options globais do Vue mudarem depois (Vue.mixin/Vue.component), o Vue
// remescla as options do ctor a partir de `extendOptions`; manter os dois em
// sincronia garante que o patch sobreviva a esse remerge.
if (ValidationProvider.extendOptions) {
    ValidationProvider.extendOptions.render = renderComMarcacao;
}
